<template>
    <div class="vue-form">
        <h2>Program Manager Approval</h2>

        <vue-form
            v-if="pmApprovalFormConfiguration && inspectionData"
            :form-config="pmApprovalFormConfiguration"
            :form-data="inspectionData"
            :form-submit-url="'/api/projects/' + projectId + '/inspections/' + inspection.phase_id + '/pmapprove'"
            :actions="actions"
            @updated="approved"
            :disabled="!phaseAvailable"
        ></vue-form>

        <span v-if="!phaseAvailable && inspection &&  inspection.pm_approved_by">
            Approved by {{ inspection.pm_approved_by.first_name }} {{ inspection.pm_approved_by.last_name}}
        </span>

    </div>
</template>
<script>
    import { byString, assignOnObject } from "laravel-vue-forms";
    export default {

        props: {
            phaseAvailable: {
                type: Number,
                default: false
            },
            projectId: {
                type: Number,
                required: true,
            },
            phaseId: {
                type: Number,
                required: true,
            }
        },

        data() {
            return {
                actions: [
                    {
                        name: 'submit',
                        label: 'Approve',
                        action: 'submitForm'
                    },
                ]
            }
        },

        created() {
            if(!this.pmApprovalFormConfiguration) {
                this.$store.dispatch('form_configurations/getFormConfiguration', 'Project Inspection PM Approval Form');
            }
        },

        computed: {
            inspection() {
                return this.$store.getters['inspections/getInspectionForProjectAndPhase'](this.projectId, this.phaseId);
            },
            inspectionData() {

                if(!this.pmApprovalFormConfiguration || !this.inspection) {
                    return null;
                }

                let inspectionData = {
                    id: this.inspection.id
                };
                this.pmApprovalFormConfiguration.fields.forEach(ff => {
                    assignOnObject(
                        inspectionData,
                        ff.value_field,
                        byString(this.inspection, ff.value_field)
                    )
                });

                return inspectionData;
            },
            pmApprovalFormConfiguration() {
                return this.$store.getters['form_configurations/getFormConfigurationByName']('Project Inspection PM Approval Form');
            }
        },

        methods: {
            approved() {
                window.notify.message('Successfully Approved Project Inspection', 'success');
                setTimeout(function() {
                    window.location.reload();
                }, 2500)

            }
        }
    }
</script>
